
// Get the API URL from environment or detect local development
export const API_URL = import.meta.env.VITE_API_URL ||
    (import.meta.env.DEV ? 'http://localhost:34977/api' : 'https://api.elimishacharity.org/api');

export const getApiUrl = () => {
    return API_URL;
};
